import React from 'react';
import { StyledTab } from '../../../styles/globalStyles';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../../store/hooks';
import { metaDataSelector } from '../../../store/globalSelectors';
import { setPaediatricEnergy } from '../../../store/slices/metaDataSlice';
import {
  isBetween,
  calcMonthsOfAge
} from '../../../shared/utils/utilFunctions';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { energyConstants } from '../../../shared/shared.constants';

function a11yProps(index: number, label: string) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
    'data-tabname': label,
    'data-testid': label
  };
}

export const TabPanel = () => {
  const {
    patientInformation,
    estimatingRequirements: { paediatricEnergy }
  } = useAppSelector(metaDataSelector);
  const dispatch = useDispatch();
  const { age, gender } = patientInformation;
  const weight =
    patientInformation.metric.estimatedDryWeight ||
    patientInformation.metric.weight;
  const calculatedAgeInMonths = calcMonthsOfAge(age.years, age.months);
  let childType;
  const genderVal = gender.toLowerCase();
  let efaVal = 0,
    efwVal = 0,
    efwKgVal = 0;
  if (isBetween(calculatedAgeInMonths, 12, 47)) {
    // 1 years to 3 years 11months
    childType = 'toddler';
  } else if (isBetween(calculatedAgeInMonths, 48, 119)) {
    // 4 years to 9 years 11months
    childType = 'kid';
  } else if (isBetween(calculatedAgeInMonths, 120, 215)) {
    // 10 years to 17 years 11months
    childType = 'teen';
  }

  const handleChange = (event: any, newValue: number) => {
    const tabName: string = event.target.dataset.tabname;
    const modifiedTabname = tabName
      .toLowerCase()
      .replace(' ', '_')
      .replace('.', '_');
    energyConstants[childType][genderVal].forEach((e) => {
      if (
        isBetween(calculatedAgeInMonths, e.minAgeInMonths, e.maxAgeInMonths)
      ) {
        efaVal = e[modifiedTabname];
        efwVal = e[modifiedTabname];
        efwKgVal = Math.round(e[modifiedTabname] / weight);
      }
    });
    dispatch(
      setPaediatricEnergy({
        ...paediatricEnergy,
        childType: childType,
        tabIndex: newValue,
        activityLevel: tabName,
        energyRequirement: {
          ...paediatricEnergy.energyRequirement,
          energyForAge: efaVal,
          energyForAgePerKg: 0,
          energyForWeight: efwVal,
          energyForWeightPerKg: efwKgVal
        }
      })
    );
  };

  return (
    <Box sx={{ width: '100%' }}>
      <Box>
        <StyledTab
          value={paediatricEnergy.tabIndex}
          onChange={handleChange}
          aria-label="Tabs example"
        >
          <Tab label={'REE'} tabIndex={0} {...a11yProps(0, 'REE')} />
          {(childType === 'toddler' || childType === 'kid') && (
            <Tab label={'PAL 1.4'} tabIndex={0} {...a11yProps(1, 'PAL 1.4')} />
          )}
          {(childType === 'kid' || childType === 'teen') && (
            <Tab label={'PAL 1.6'} tabIndex={0} {...a11yProps(2, 'PAL 1.6')} />
          )}
          {(childType === 'kid' || childType === 'teen') && (
            <Tab label={'PAL 1.8'} tabIndex={0} {...a11yProps(3, 'PAL 1.8')} />
          )}
          {childType === 'teen' && (
            <Tab label={'PAL 2.0'} tabIndex={0} {...a11yProps(4, 'PAL 2.0')} />
          )}
        </StyledTab>
      </Box>
    </Box>
  );
};
